import { render, staticRenderFns } from "./gs-summary-display.vue?vue&type=template&id=4a9894b9"
import script from "./gs-summary-display.vue?vue&type=script&lang=ts"
export * from "./gs-summary-display.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports